import { create } from 'zustand'

const useRoasStore = create((set) => ({
  fixMode: 'raw',
  displayMode: 'percentage',
  dayMode: 'cumulative',
  dayOrder: 'asc', // 'asc' for Day 0 -> Day N, 'desc' for Day N -> Day 0
  viewMode: 'lifecycle', // 'lifecycle' or 'calendar'
  displayAdMode: 'ecpm',
  retDisplayMode: 'percentage',
  userSourceType: 'active',
  denominatorSource: 'Firebase',
  weekFilter: null, // null means show all days
  summaryMode: 'daily', // 'daily', 'weekly', 'monthly'
  multiplierDenominatorMode: 'd0_revenue', // 'd0_revenue', 'target_roas', 'growth_rate'
  compareDiffMode: false,
  setFixMode: (mode) => set({ fixMode: mode }),
  setDisplayMode: (mode) => set({ displayMode: mode }),
  setDayMode: (mode) => set({ dayMode: mode }),
  setDayOrder: (order) => set({ dayOrder: order }),
  setViewMode: (mode) =>
    set({
      viewMode: mode,
      dayMode: mode === 'calendar' ? 'daily' : 'cumulative',
    }),
  setDisplayAdMode: (mode) => set({ displayAdMode: mode }),
  setWeekFilter: (day) => set({ weekFilter: day }),
  setRetDisplayMode: (mode) => set({ retDisplayMode: mode }),
  setUserSourceType: (mode) => set({ userSourceType: mode }),
  setDenominatorSource: (mode) => set({ denominatorSource: mode }),
  setSummaryMode: (mode) => set({ summaryMode: mode }),
  setMultiplierDenominatorMode: (mode) => set({ multiplierDenominatorMode: mode }),
  setCompareDiffMode: (mode) => set({ compareDiffMode: mode }),
}))


export const useRoasNoteStore = create((set) => ({
  date: '',
  cid: '',
  open: false,
  showNotes: (payload) => {
    const { date, cid } = payload
    set({ date, cid, open: true })
  },
  onOpenChange: (value) => {
    if (value) {
      set({ open: true })
    } else {
      set({ open: false, date: '', cid: '' })
    }
  },
}))

export { useRoasStore }
